<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-08 19:53:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 16:19:48
-->
<template>
  <div class="bigbox">
    <v-divider class="animated fadeIn delay-1s maxwidth" />
    <div
      class="sheets"
      :style="{
        right: left ? 'initial' : right + 'px',
        left: left + 'px' ? left : 'initial',
      }"
    >
      <span
        class="grey--text"
        style="font-size:12px;white-space: normal nowrap;padding-right: 20px;"
        v-if="isShow"
      >
        {{ options.cpage == 1 ? 1 : (options.cpage - 1) * options.pagesize }}
        -
        {{ this.pageStop }}
        <span>{{ $t("label_column") }}</span>
        <span class="pl-1">
          ({{ $t("label_total") }}
          <span>{{ options.totalcount }}</span>
          {{ $t("label_column") }})
        </span>
      </span>
      <div class="d-flex">
        <v-pagination
          v-model="options.cpage"
          circle
          color="grey lighten-2 black--text"
          class="black--text d-flex"
          prev-icon="navigate_before"
          next-icon="navigate_next"
          :length="options.totalpage ? options.totalpage : 1"
          @input="turnPage"
          :total-visible="7"
        />
        <span
          class="grey--text d-flex align-center"
          style=" font-size: 12px;white-space: normal nowrap;padding-left: 20px;padding-right: 10px;"
          v-if="isShow"
        >
          {{ $t("label_Each_page_shows") }}
        </span>
        <v-menu offset-y v-if="isShow" small>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              depressed
              class="text-capitalize grey--text pr-0 mt-3 mb-3"
              text
              color="grey lighten-1"
              outlined
            >
              {{ options.pagesize }}
              <i class="material-icons">arrow_drop_down</i>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="(item, index) in options.selectlist"
              :key="index"
              @click="setPerPage(item)"
            >
              <v-list-item-title>
                {{ item == -1 ? options.pagesize : item }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
/*  @info 分页器
 *  options 结构
 *  options: {  //必填
        pagesize: 4,//条数
        cpage: this.$store.state.cpage,  //当前页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [5, 10, 15, 20], //
        pagetext: this.$t('label_Each_page_shows') //
      }
 *  @params {right}  居右   默认居右20px
 *  @params {left }   居左  
 *  @params {isShow} 默认显示全部  false只显示分页
 *  @event change 获取 整个options 配置
 
<mrc_ess_paginationsinations v-model='options'
                         @change="turnPage"></mrc_ess_paginationsinations>
  options: {
        pagesize: 5,//条数
        cpage: this.$store.state.cpage,  //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [5, 10, 15, 20],
        pagetext: this.$t('label_Each_page_shows')
      },
this.options.totalcount = res.totalcount
this.options.totalpage = res.totalpage
*/
export default {
  name: "mrc_ess_paginationsWeb",
  computed: {
    pageStop() {
      if (this.options.cpage == this.options.totalpage) {
        return this.options.cpage == 1
          ? this.options.totalcount
          : (this.options.cpage - 1) * this.options.pagesize +
              (this.options.totalcount -
                (this.options.cpage - 1) * this.options.pagesize)
      } else {
        return this.options.cpage * this.options.pagesize
      }
    },
  },
  mounted() {},
  props: {
    options: {
      type: Object,
    },
    right: {
      type: Number,
      default: 20,
    },
    left: {
      type: Number,
      default: null,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  model: {},
  watch: {},
  data() {
    return {}
  },
  methods: {
    /**
     * @description: 改变每页条数
     * @param {type}
     * @return:
     * @author: lwq
     */
    setPerPage(perpage) {
      this.$emit("setPerPage", perpage, this.options)
    },
    /**
     * @description: 点击页码
     * @param {type}
     * @return:
     * @author: lwq
     */
    turnPage(page) {
      this.$emit("change", page, this.options)
    },
  },
}
</script>

<style scoped>
.sheets {
  display: flex;
  padding: 0 12px;
  justify-content: space-between;
  align-content: center;
  /* right: 10px; */
}
.bigbox {
  height: 55px;
  position: relative;
}
.v-pagination {
  padding: 0;
  width: initial;
}
.bigbox /deep/ .v-pagination__item {
  height: 20px;
  min-width: 20px;
  font-size: 12px;
  box-shadow: initial;
}
.bigbox /deep/ .v-pagination__navigation {
  height: 30px;
  min-width: 30px;
  font-size: 12px;
  transform: scale(0.8);
  box-shadow: initial;
}
.bigbox /deep/ .v-pagination--circle .v-pagination__item {
  border-radius: 4px !important;
}
</style>
